// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginback{
  /* background-image: url(''); */
  height: 100vh;
  width: 50vw;
  background-size: contain;
  background-repeat: no-repeat;
  background-size: 50vw 100vh;
  flex-wrap: wrap;
}

.sidepage{
  /* background-image: url(''); */
  height: 100vh;
  width: 50vw;
  background-size: contain;
  background-repeat: no-repeat;
  background-size: 49vw 100vh;
}
.imge{
    padding: 4px;
    height: 7rem;
    width: 9.5rem;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,aAAa;EACb,WAAW;EACX,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,WAAW;EACX,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".loginback{\n  /* background-image: url(''); */\n  height: 100vh;\n  width: 50vw;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-size: 50vw 100vh;\n  flex-wrap: wrap;\n}\n\n.sidepage{\n  /* background-image: url(''); */\n  height: 100vh;\n  width: 50vw;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-size: 49vw 100vh;\n}\n.imge{\n    padding: 4px;\n    height: 7rem;\n    width: 9.5rem;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
